import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/coreka/Interview/Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import { firstViewItemWhite, overviewItem, overviewTitle, issueSolutionItems } from './CorekaItem'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import styles from 'components/cases/coreka/coreka.module.scss'

const Coreka = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
      <MailmagazineLink />
  </>
  )
}

export default Coreka
